import React, { useEffect, useState, useMemo } from 'react';
import { useFormikContext } from 'formik';
import { useSelector } from 'react-redux';
import { DropdownButton, Dropdown } from 'react-bootstrap';
import { format } from 'date-fns';

import BookingHelper from 'modules/shared/BookingTable/utils';
import { logoutSelector } from 'modules/common/LogoutBtn/selectors';

import styles from './DateTimePicker.module.scss';

type Props = {
  name: string;
  isDisabled?: boolean;
};

const DateTimePicker: React.FC<Props> = ({ name, isDisabled = false }) => {
  const formik = useFormikContext();
  const { branchTitle } = useSelector(logoutSelector);
  const [date, setDate] = useState('');
  const [times, setTimes] = useState(['']);
  const [time, setTime] = useState('');

  const slotSetting = branchTitle?.cellSetting;

  const today = new Date();
  const tomorrow = new Date(today);

  const { values, setFieldValue } = formik;

  useMemo(() => {
    if (slotSetting) {
      const curTimes = BookingHelper.generateTimes(slotSetting);

      setTimes(curTimes);
    }
  }, []);

  const handleChange = (e: any) => {
    const duration = slotSetting?.slotDurationInMinutes || 30;
    let newDateTime = '';

    if (e?.target?.value) {
      newDateTime = `${e?.target?.value} ${time}`;
      setDate(e.target.value);
    } else {
      newDateTime = `${date} ${e}`;
      setTime(e);
    }

    const dateFormat = new Date(newDateTime);

    const checkOutTime = new Date(dateFormat).getMinutes() + +duration;
    const checkOutDate = new Date(dateFormat).setMinutes(checkOutTime);
    const checkOutDateF = format(new Date(checkOutDate), "yyyy-MM-dd'T'HH:mm:ss");

    setFieldValue('checkInDate', format(dateFormat, "yyyy-MM-dd'T'HH:mm:ss"));
    setFieldValue('checkOutDate', checkOutDateF);
    setFieldValue('bookCellId', '');
    setFieldValue('bookingStatus', 1);
    setFieldValue(name, newDateTime);
  };

  useEffect(() => {
    if (name && values) {
      // @ts-ignore
      const dateFormat = format(new Date(values[name]), 'yyyy-MM-dd');
      // @ts-ignore
      const timeFormat = BookingHelper.formatTime(new Date(values[name]));

      setTime(timeFormat);
      setDate(dateFormat);
    }
  }, [name]);

  return (
    <div className={styles.dateTimePicker}>
      <input
        type="date"
        min={format(tomorrow.setDate(today.getDate() + 1), 'yyyy-MM-dd')}
        onChange={handleChange}
        className={styles.inputDate}
        value={date}
        disabled={isDisabled}
      />
      <DropdownButton
        title={time}
        variant="outline-secondary"
        className={styles.selectTime}
        onSelect={handleChange}
        disabled={isDisabled}
      >
        <div className={styles.dropdownMenu}>
          {times.map((t: any) => (
            <Dropdown.Item key={t} eventKey={t}>
              {t}
            </Dropdown.Item>
          ))}
        </div>
      </DropdownButton>
    </div>
  );
};

export default DateTimePicker;
